import React, { useState, useEffect } from "react";
import { Alert, Button } from "react-bootstrap";
import CircularProgress from "@mui/material/CircularProgress";
import { IoMdDownload } from "react-icons/io";
import XLSX from "xlsx";
import AADService from "../funcionesAuth.js";

function AlertDismissibleExample({ alerta }) {
  switch (alerta) {
    case 1:
      return <Alert variant='warning'>Alerta</Alert>;
      break;
    case 2:
      return <Alert variant='success'>Guardó exitosamente</Alert>;
      break;
    case 3:
      return <Alert variant='danger'></Alert>;
      break;
    case 4:
      return <Alert variant='warning'>Error al enviar la información</Alert>;
      break;
    case 5:
      return <Alert variant='danger'>Error en el servidor</Alert>;
      break;
    case 6:
      return (
        <Alert variant='warning'>
          Ya existe una evaluación para el activo seleccionado
        </Alert>
      );
      break;
    default:
      return <p></p>;
      break;
  }
}

export default function InformeVSC() {
  const [estadoPOST, setEstadoPost] = useState(0);
  const [evaluaciones, setEvaluaciones] = useState([]);
  const [riesgos, setRiesgos] = useState([]);
  const [planesAccion, setPlanesAccion] = useState([]);
  const [datosVSC, setDatosVSC] = useState([]);
  const [datosCSC, setDatosCSC] = useState([]);
  const [loading, setLoading] = useState(true);
  const [loadingCSC, setLoadingCSC] = useState(true);
  const [rolUser, setRolUser] = useState(0);
  const [alerta, setAlerta] = useState([]);
  const AzureADService = new AADService();
  const token = AzureADService.getToken();


  useEffect(() => {
    const generarInfo = async () => {
      const result = await fetch(
        process.env.REACT_APP_API_URL + "informes/VSC/",
        {
          method: "GET",
          headers: {
            "Content-type": "application/json;",
            Authorization: "Bearer " + token,
          },
        }
      );
      let datainfo = await result.json();

      setDatosVSC(datainfo);
      setLoading(false);
    };
    const generarInfoCSC = async () => {
      const result = await fetch(
        process.env.REACT_APP_API_URL + "informes/CSC/",
        {
          method: "GET",
          headers: {
            "Content-type": "application/json;",
            Authorization: "Bearer " + token,
          },
        }
      );
      let datainfoCSC = await result.json();

      setDatosCSC(datainfoCSC);
      setLoadingCSC(false);
    };
    const fetchAlertasGenerales = async () => {
      try {
        const response = await fetch(
          process.env.REACT_APP_API_URL +
          "evaluacion/nuevaevaluacion/bandeja/1/" + localStorage.getItem("idcompania") + "/",
          {
            method: "GET",
            headers: {
              "Content-Type": "application/json",
              Authorization: "Bearer " + token,
            },
          }
        );
        if (!response.ok) throw new Error("Error al obtener alertas");

        const data = await response.json();

        setAlerta(data);
      } catch (error) {
        console.error("Error al obtener alertas:", error);
      }
    };

    fetchAlertasGenerales();
    generarInfo();
    generarInfoCSC();
    let rol = localStorage.getItem("rolusuario");
    setRolUser(rol);
  }, []);

  const handleOnExport = () => {
    let datosVSCFiltrados = datosVSC.filter((item) => {
      return item.idcompania === parseInt(localStorage.getItem("idcompania"));
    });
    let nameCompania = datosVSCFiltrados[0].nombreregional;

    const newBook = XLSX.utils.book_new(),
      sheet1 = XLSX.utils.json_to_sheet(datosVSCFiltrados);
    XLSX.utils.book_append_sheet(newBook, sheet1, "Informe_VSC");
    XLSX.writeFile(newBook, "Informe_VSC_" + nameCompania + ".xlsx");
  };

  const handleOnExportCSC = () => {
    const newBook = XLSX.utils.book_new();
    const sheet1 = XLSX.utils.json_to_sheet(datosCSC.hoja_1);
    const sheet2 = XLSX.utils.json_to_sheet(datosCSC.hoja_2);
    const sheet3 = XLSX.utils.json_to_sheet(datosCSC.hoja_3);
    XLSX.utils.book_append_sheet(newBook, sheet1, "Riesgo por Efecto");
    XLSX.utils.book_append_sheet(newBook, sheet2, "Mezcla independientes");
    XLSX.utils.book_append_sheet(newBook, sheet3, "Informe_CSC");
    XLSX.writeFile(newBook, "Informe_CSC.xlsx");
  };

  const handleOnExportalerta = () => {
    if (!alerta || alerta.length === 0) return;
    const ws = XLSX.utils.json_to_sheet(alerta);
    const wb = XLSX.utils.book_new();
    XLSX.utils.book_append_sheet(wb, ws, "Alertas");
    XLSX.writeFile(wb, "Informe alertas.xlsx");
  };


  return (
    <div className='d-flex flex-column'>
      {datosVSC && datosVSC.length > 0 && (
        <>
          <AlertDismissibleExample alerta={estadoPOST} />
          <h2 className='titulo'>Informe VSC</h2>
          <hr />
          {loading ? (
            <CircularProgress />
          ) : (
            <div className='d-flex justify-content-center align-items-center col-12'>
              <Button className='botonPositivo' onClick={handleOnExport}>
                Descargar informe de VSC &nbsp;
                <IoMdDownload />
              </Button>
            </div>
          )}
        </>
      )}
      {datosCSC && (rolUser == 1 || rolUser == 2) && (
        <>
          <AlertDismissibleExample alerta={estadoPOST} />
          <h2 className='titulo'>Informe de centro de servicios compartidos</h2>
          <hr />
          {loading ? (
            <CircularProgress />
          ) : (
            <div className='d-flex justify-content-center align-items-center col-12'>
              <Button className='botonPositivo' onClick={handleOnExportCSC}>
                Descargar informe de CSC &nbsp;
                <IoMdDownload />
              </Button>
            </div>
          )}
        </>
      )}
      <>
        <h2 className='titulo'>Informe de Alertas del Sistema</h2>
        <hr />
        {loading ? (
          <CircularProgress />
        ) : (
          <div className='d-flex justify-content-center align-items-center col-12'>
            <Button className='botonPositivo' onClick={handleOnExportalerta}>
              Descargar informe de alertas &nbsp;
              <IoMdDownload />
            </Button>
          </div>
        )}
      </>
    </div>
  );
}
